import React, { useState } from "react";

import PredeterminadosVentas from "./PredeterminadosVentas";

export default function SalesSettingsScreen(props) {
  const [selectedTab, setSelectedTab] = useState(0);

  if (!props.show) {
    return <></>;
  }

  return (
    <div>
      <div className="optometry-icon-header">
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 0 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(0);
          }}
        >
          <img
            src={
              selectedTab === 0
                ? "/images/optometry-orange.svg"
                : "/images/optometry-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Predeterminados ventas</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 1 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(1);
          }}
        >
          <img
            src={
              selectedTab === 1
                ? "images/anamnesis-orange.svg"
                : "/images/anamnesis-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Descripción de artículos</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 2 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(2);
          }}
        >
          <img
            src={
              selectedTab === 2
                ? "/images/rx-orange.svg"
                : "/images/rx-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>GFK</span>
        </button>
        <button
          className={`optometry-icon-header-icon ${
            selectedTab === 3 ? "bkg-orange" : ""
          }`}
          disabled={false}
          onClick={() => {
            setSelectedTab(3);
          }}
        >
          <img
            src={
              selectedTab === 3
                ? "/images/accommodative-orange.svg"
                : "/images/accommodative-blue.svg"
            }
            loading="lazy"
            alt="Icon"
          ></img>
          <span>Descuento máximo</span>
        </button>
      </div>
      <div className="cfg-body-container">
        {selectedTab === 0 && (
          <PredeterminadosVentas {...props} show={selectedTab === 0} />
        )}
      </div>
    </div>
  );
}
